import React, { useState, useEffect, useContext } from "react";
import { Box, MenuItem, Menu, Typography, IconButton,  Stack, FormGroup, FormControlLabel, Switch } from "@mui/material";
import { AccountCircle, Logout, SupervisorAccount } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import userService from "../services/userService";
import companyService from "../services/companyService";
import { ThemeModeContext } from "../shared/Theme";

const Header = () => {
	const themeModeContext = useContext(ThemeModeContext);
	
	const navigate = useNavigate();
	let [ anchorE1, setAnchorEl ] = useState(null);
	let [ company, setCompany ] = useState(companyService.selectedCompany);
	
	useEffect(() => {
		themeModeContext.setThemeMode(localStorage.getItem("cymplify_theme_mode"));
		companyService.onSelectCompany(() => {
			setCompany(companyService.selectedCompany);
		});
	}, []);
	
	const handleMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};
	
	const handleClose = () => {
		setAnchorEl(null);
	};
	
	const handleAdminArea = () => {
		setAnchorEl(null);
		navigate("/admin");
	};
	
	const handleLogout = () => {
		userService.logout();
		setAnchorEl(null);
		navigate("/login");
	};
	
	const handleDarkModeSwitch = (event) => {
		const mode = (event.target.checked)? "dark" : "light";
		localStorage.setItem("cymplify_theme_mode", mode);
		themeModeContext.setThemeMode(mode);
	};
	
	// const headerBarStyle = {
	// 	flexGrow: 1,
	// 	bgcolor: "background.header",
	// 	color: "text.header",
	// 	position: "static"
	// };
	
	return (
		<Stack direction="row" justifyContent="right" sx={{ width: "100%", color: "text.secondary" }}>
			<Box>
				<IconButton
					size="large"
					aria-label="account of current user"
					aria-controls="menu-appbar"
					aria-haspopup="true"
					onClick={handleMenu}
					color="inherit"
				>
					<AccountCircle />
				</IconButton>
				<Menu
					id="menu-appbar"
					anchorEl={anchorE1}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					keepMounted
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					open={Boolean(anchorE1)}
					onClose={handleClose}
					sx={{ minWidth: "200em" }}
				>
					<Typography sx={{ textAlign: "center", marginBottom: "0.75em", padding: "0 1em 0 1em" }}>
						{ company.name }
					</Typography>
					<MenuItem>
						<FormGroup>
							<FormControlLabel
								control={
									<Switch
										checked={themeModeContext.themeMode !== "light"}
										onChange={handleDarkModeSwitch}
									/>
								}
								label="Dark Mode"
							/>
						</FormGroup>
					</MenuItem>
					<MenuItem onClick={handleAdminArea}>
						<SupervisorAccount sx={{marginRight: "1em"}}/>Admin Area
					</MenuItem>
					<MenuItem onClick={handleLogout}>
						<Logout sx={{marginRight: "1em"}}/>Logout
					</MenuItem>
				</Menu>
			</Box>
		</Stack>
	);
}

export default Header;
